/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Settings_Tabs_LabelInputs */

const en_live_caption_settings_tabs_label = /** @type {(inputs: Live_Caption_Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live captioning settings tabs`)
};

const fr_live_caption_settings_tabs_label = /** @type {(inputs: Live_Caption_Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onglets des paramètres de sous-titrage en direct`)
};

const de_live_caption_settings_tabs_label = /** @type {(inputs: Live_Caption_Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registerkarten für Live-Untertitelungseinstellungen`)
};

const it_live_caption_settings_tabs_label = /** @type {(inputs: Live_Caption_Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schede delle impostazioni dei sottotitoli in tempo reale`)
};

const ru_live_caption_settings_tabs_label = /** @type {(inputs: Live_Caption_Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вкладки настроек субтитров в реальном времени`)
};

const es_live_caption_settings_tabs_label = /** @type {(inputs: Live_Caption_Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pestañas de configuración de subtítulos en directo`)
};

const zh_cn2_live_caption_settings_tabs_label = /** @type {(inputs: Live_Caption_Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时字幕设置选项卡`)
};

const ja_live_caption_settings_tabs_label = /** @type {(inputs: Live_Caption_Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブキャプション設定タブ`)
};

const hi_live_caption_settings_tabs_label = /** @type {(inputs: Live_Caption_Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव कैप्शनिंग सेटिंग्स टैब`)
};

const pt_pt2_live_caption_settings_tabs_label = /** @type {(inputs: Live_Caption_Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`guias de configurações de legendas ao vivo`)
};

/**
* | output |
* | --- |
* | "Live captioning settings tabs" |
*
* @param {Live_Caption_Settings_Tabs_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_settings_tabs_label = /** @type {((inputs?: Live_Caption_Settings_Tabs_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Settings_Tabs_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_settings_tabs_label(inputs)
	if (locale === "de") return de_live_caption_settings_tabs_label(inputs)
	if (locale === "it") return it_live_caption_settings_tabs_label(inputs)
	if (locale === "ru") return ru_live_caption_settings_tabs_label(inputs)
	if (locale === "es") return es_live_caption_settings_tabs_label(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_settings_tabs_label(inputs)
	if (locale === "ja") return ja_live_caption_settings_tabs_label(inputs)
	if (locale === "hi") return hi_live_caption_settings_tabs_label(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_settings_tabs_label(inputs)
	return en_live_caption_settings_tabs_label(inputs)
});